<template>
  <div id="container">
    <div
      v-if="!isWeb"
      class="top"
      :style="{ position: isWeb ? 'absolute' : 'fixed' }"
      @click="backClick"
    >
      <img
        src="https://imagessl.edujia.com/A-1ed71af7_20230804162525.png"
        crossorigin="Anonymous"
      />
      <div>返回</div>
    </div>
    <div
      class="psBar"
      :style="{ 'padding-top': isWeb ? '0' : '84px' }"
    >
      <div>导入说明：</div>
      <div>
        导入txt，话术分类和内容在一个文件里，<span @click="modelLinkClick"
          >txt模板</span
        >
      </div>
    </div>
    <div class="actionBar">
      <div class="actionBarL">
        导入至<span>{{ teamName }}</span>
      </div>
      <div
        v-if="currentFile"
        class="actionBarR actionBarRDisable"
      >
        选择文件
      </div>
      <div
        v-else
        class="actionBarR"
        @click="fileChoose"
      >
        选择文件
      </div>
    </div>
    <div class="uploadArea">
      <div
        v-if="!currentFile"
        class="uploadAreaMain"
        @click="fileChoose"
      >
        <img src="https://imagessl.lingtuo.cn/A-1ed71af7_20240716140247.png" />
        <div>点击选择文件</div>
      </div>
      <div
        v-else
        class="uploadAreaMain"
      >
        <img :src="fileIcon" />
        <div>{{ currentFile.name }}</div>
      </div>
      <input
        v-show="false"
        type="file"
        ref="fileInput"
        @change="fileChange"
      />
    </div>

    <div class="btnBar">
      <div
        class="btnBarL"
        @click="backClick"
      >
        取消
      </div>
      <div
        class="btnBarR"
        @click="importClick"
      >
        确定导入
      </div>
    </div>
  </div>
</template>

<script>
import jschardet from "jschardet";

export default {
  props: ["isWeb", "speechIdProps", "labelIdProps"],
  data() {
    return {
      pageWidth:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      pageHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      speechId: this.$route.query.speechId || this.speechIdProps,
      labelId: this.$route.query.labelId || this.labelIdProps,
      teamName: this.$route.query.teamName,
      currentFile: null,
      convertFileDataResult: null,
      loading: null,
    };
  },
  computed: {
    fileIcon() {
      if (this.currentFile) {
        return this.getFileIcon(this.currentFile.name);
      }
      return "";
    },
  },
  methods: {
    //合并名称相同的分类
    mergeAndFilter(arr) {
      const merged = {};
      arr.forEach((obj) => {
        if (!merged[obj.type]) {
          merged[obj.type] = obj;
        } else {
          merged[obj.type].sub.push(...obj.sub);
        }
      });
      return Object.values(merged);
    },
    async importClick() {
      this.convertFileDataResult = this.mergeAndFilter(
        this.convertFileDataResult
      );

      this.loading = this.$loading.service({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
      //上传type
      let params = {
        speechId: this.speechId,
        labelNameArray: JSON.stringify(
          this.convertFileDataResult.map((val) => {
            return val.type;
          })
        ),
      };
      let resp = await this.$http.huashuTypeBatSave(params);
      if (resp.code == 200) {
        resp.data.array.map((type) => {
          this.convertFileDataResult.find((item) => {
            if (item.type == type.labelName) {
              Object.assign(item, type);
            }
            return item.type == type.labelName;
          });
        });
      } else {
        this.$message({
          message: resp.message,
          type: "warning",
        });
      }

      //上传话术
      let speechTextArray = [];
      this.convertFileDataResult.forEach((typeItem) => {
        console.log("typeItem.labelId:", typeItem.labelId);
        typeItem.sub.forEach((huashuItem) => {
          speechTextArray.push({
            labelId: typeItem.labelId,
            speechText: huashuItem.content,
            title: huashuItem.title,
            isCarryTitle: 0,
            editTime: 0,
          });
        });
      });

      //服务端限制单次保存500个
      const chunkSize = 500;
      for (let i = 0; i < speechTextArray.length; i += chunkSize) {
        await this.huashuBatSave(speechTextArray.slice(i, i + chunkSize));
      }

      this.loading.close();
      this.$message({
        message: "上传成功",
        type: "warning",
      });
      localStorage.setItem("needReresh", true);
      if (this.isWeb) {
        this.$emit("huashuImportClose");
      } else {
        this.$router.go(-1);
      }
    },
    async huashuBatSave(speechTextArray) {
      return new Promise(async (resolve, reject) => {
        let huashuParams = {
          speechId: this.speechId,
          speechTextArray: JSON.stringify(speechTextArray),
        };
        let huashuResp = await this.$http.huashuBatSave(huashuParams);
        console.log("huashuTypeBatSave resp:", huashuResp);
        if (huashuResp.code == 200) {
          // this.loading.close()
          // this.$message({
          //   message: '上传成功',
          //   type: 'warning'
          // });
          // localStorage.setItem('needReresh',true)
          // this.$router.go(-1)
          resolve();
        } else {
          this.loading.close();
          this.$message({
            message: huashuResp.message,
            type: "warning",
          });
        }
      });
    },
    fileChoose() {
      this.$refs.fileInput.click();
    },
    tmpConvert(text) {
      // const replacedStr =str.replace(/(?!【[^】]+】.*：)\【([^】]+)】\n/g, '{$1}\n')
      // const replacedStr = str.replace(/(?!【[^】]+】.*：)\【([^】]+)】\n|■/g, (match, p1) => {
      //     if (p1 !== undefined) {
      //         return `{${p1}}\n`;
      //     } else {
      //         return '■ ';
      //     }
      // });
      // return replacedStr

      // 以换行符分割文本为行数组
      var lines = text.split("\n");
      // 循环处理每一行文本
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim(); // 去除首尾空格
        // 如果该行文本除了换行符、缩进符和空格外没有其他字符，并且包含中文括号【】
        if (line.match(/^[\t\s]*【.*】[\t\s]*$/) && !line.match(/^[\t\s]*$/)) {
          // 将中文括号【】替换为英文花括号{}
          lines[i] = line.replace(/【/g, "{").replace(/】/g, "}");
        }
        // 在每个'■'后面加入一个空格
        lines[i] = lines[i].replace(/■/g, "■ ");
      }
      // 重新组合文本行数组为文本字符串
      var convertedText = lines.join("\n");
      return convertedText;
    },
    convertFileData(text) {
      text = this.tmpConvert(text);
      // const regex = /【([^【】]+)】(?:[\s\S]*?)?(?=(?:【|$))/g;
      const regex = /(?:\n|^){([^{}]+)}(?:[\s\S]*?)?(?=(?:\n{|$))/g;
      let matches;
      const result = [];

      while ((matches = regex.exec(text)) !== null) {
        const category = matches[1].trim();
        const categoryText = matches[0].trim();

        // 解析分类中的标题和内容
        const categoryRegex = /■([^【\n]+)\n([^■]*)/g;
        let categoryMatches;
        const categoryData = [];

        while ((categoryMatches = categoryRegex.exec(categoryText)) !== null) {
          const title = categoryMatches[1].trim();
          const content = categoryMatches[2].trim().replace(/\n+/g, "\n");
          categoryData.push({ title, content });
        }

        // 添加分类到结果数组
        result.push({ type: category, sub: categoryData });
      }
      console.log("convertFileData result:", result);
      this.convertFileDataResult = result;

      // console.log("convertFileData result:",result);
      // this.convertFileDataResult=result;
    },
    modelLinkClick() {
      // 获取要下载的文件 URL
      // var fileUrl = 'https://team.edujia.com/%E8%AF%9D%E6%9C%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.txt'; // 替换为你的文件 URL
      var fileContent = `【分类1】

■ 标题1（选填）
话术内容

■ 标题2（选填）
话术内容2

■   
话术内容3

【分类2】

■   
话术内容

■   
话术内容
话术内容

■   
话术内容3

■   
话术内容4`;

      // 创建一个 Blob 对象
      var blob = new Blob([fileContent], { type: "text/plain" });

      // 创建一个临时的 URL
      var url = URL.createObjectURL(blob);

      // 创建一个 <a> 元素并设置其属性
      var link = document.createElement("a");
      link.href = url;
      link.download = "downloaded_file.txt"; // 设置下载的文件名

      // 将 <a> 元素添加到 DOM 中
      document.body.appendChild(link);

      // 模拟点击 <a> 元素来触发下载
      link.click();

      // 下载完成后释放 URL 对象
      setTimeout(function () {
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }, 100);

      // var link = document.createElement('a');
      // link.href = "https://team.edujia.com/%E8%AF%9D%E6%9C%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.txt";
      // link.download = '话术导入模板.txt'
      // document.body.appendChild(link);
      // link.click();
      // setTimeout(()=>{
      //     document.body.removeChild(link);
      // },100)
    },
    backClick() {
      if (this.isWeb) {
        this.$emit("huashuImportClose");
        return;
      }
      this.$router.go(-1);
    },
    fileChange(e) {
      // let files=e.currentTarget.files
      // for(let i=0;i<files.length;i++){
      // let file=files[i];
      let file = e.currentTarget.files[0];
      this.currentFile = file;
      if (file.name.includes(".docx")) {
        this.parseWordDocxFile(file);
      } else if (file.name.includes(".txt")) {
        this.parseTxtFile(file);
      }
      // }
    },
    parseWordDocxFile(file) {
      // let inputElement=e.currentTarget
      // var files = inputElement.files || [];
      // if (!files.length) return;
      // var file = files[0];
      let _this = this;
      var reader = new FileReader();
      reader.onloadend = function (event) {
        var arrayBuffer = reader.result;
        // debugger

        // mammoth.convertToHtml({arrayBuffer: arrayBuffer}).then(function (resultObject) {
        //   // result1.innerHTML = resultObject.value
        //   console.log(resultObject.value)
        // })
        // console.timeEnd();

        mammoth
          .extractRawText({ arrayBuffer: arrayBuffer })
          .then(function (resultObject) {
            // result2.innerHTML = resultObject.value
            console.log(resultObject.value);
            _this.convertFileData(resultObject.value);
          });

        // mammoth.convertToMarkdown({arrayBuffer: arrayBuffer}).then(function (resultObject) {
        //   // result3.innerHTML = resultObject.value
        //   console.log(resultObject.value)
        // })
      };
      reader.readAsArrayBuffer(file);
    },
    varifyTxtIsError(str) {
      // 使用正则表达式匹配常见的乱码字符
      const mojibakeRegex = /[\uFFFD\uFFFE\uFFFF]/g;
      return mojibakeRegex.test(str);
    },
    parseTxtFile(file) {
      const _this = this;
      const reader = new FileReader();

      // 1. 关键修改：使用 readAsArrayBuffer 读取原始二进制流，而不是 readAsText
      reader.readAsArrayBuffer(file);

      reader.onload = function (event) {
        try {
          const buffer = event.target.result;
          const view = new Uint8Array(buffer);

          // 2. 截取一部分数据传给 jschardet 进行检测
          // 为了性能，不需要检测整个大文件，通常前 4096 个字节足够判断编码
          let binaryString = "";
          const len = Math.min(view.length, 4096);
          for (let i = 0; i < len; i++) {
            binaryString += String.fromCharCode(view[i]);
          }

          // 3. 检测编码
          const result = jschardet.detect(binaryString);
          let encoding = result.encoding;

          // 容错处理：如果没检测出来，或者置信度太低，默认回退到 utf-8 或 gbk
          // 注意：jschardet 有时会把 GBK 识别为 windows-1252，需要根据你的业务场景决定是否修正
          if (!encoding || result.confidence < 0.5) {
            encoding = "utf-8";
          }

          // 修正常见的 GBK 识别偏差（视具体库版本而定，有时 windows-1252 实际应处理为 GBK/GB18030）
          // 如果你的用户主要在中文环境，可以保留下面的逻辑，否则可以去掉
          if (encoding === "windows-1252") {
            // 这里由你自己决定，保守起见可以保留原样，或者强制尝试 gbk
            // encoding = 'gb18030';
          }

          console.log("检测到的编码:", encoding, "置信度:", result.confidence);

          // 4. 使用 TextDecoder 进行解码
          // TextDecoder 是现代浏览器标准 API，支持 gbk, big5, shift-jis 等
          const decoder = new TextDecoder(encoding);
          const content = decoder.decode(view);

          _this.convertFileData(content);
        } catch (e) {
          console.error("解析文件失败", e);
          // 如果出错，最后尝试一次硬编码读取（比如强制 GBK）
          // const reader2 = new FileReader();
          // reader2.onload = (e2) => _this.convertFileData(e2.target.result);
          // reader2.readAsText(file, "gbk");
          alert("不支持的编码格式，请使用utf-8或gbk编码的txt文件");
        }
      };

      reader.onerror = function () {
        console.error("文件读取发生错误");
      };
    },
    // parseTxtFile(file) {
    //   let _this = this;
    //   const reader = new FileReader();
    //   reader.onload = function (event) {
    //     let content = event.target.result;
    //     const result = jschardet.detect(content);
    //     // if (_this.varifyTxtIsError(content)) {
    //     if (result.encoding === "GB2312" || result.encoding === "GBK") {
    //       const reader2 = new FileReader();
    //       reader2.onload = function (event2) {
    //         let content2 = event2.target.result;
    //         _this.convertFileData(content2);
    //       };
    //       reader2.readAsText(file, "gbk");
    //     } else {
    //       _this.convertFileData(content);
    //     }
    //   };
    //   reader.readAsText(file, "utf-8");
    // },
    getFileIcon(fileName) {
      let icon = "";
      if (fileName.includes(".doc")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143256.png";
      } else if (fileName.includes(".txt")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143245.png";
      } else if (fileName.includes(".xls")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143214.png";
      } else if (fileName.includes(".mp3") || fileName.includes(".m4a")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114041.png";
      } else if (fileName.includes(".pdf")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114100.png";
      } else if (fileName.includes(".ppt") || fileName.includes(".pptx")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230608114321.png";
      } else {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230601152642.png";
      }
      return icon;
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.top {
  width: 100%;
  height: 52px;
  color: #4a90e2;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 25px;
  position: fixed;
  left: 0;
  top: 32px;
  background-color: #fff;
}

.top img {
  width: 20px;
  height: 20px;
  margin-left: 14px;
  margin-right: 4px;
}

.psBar {
  padding-top: 84px;
  padding-left: 16px;
  line-height: 25px;
  height: 50px;
  background-color: #fcf6df;
  font-size: 12px;
  min-width: 300px;
}

.psBar span {
  color: #4a90e2;
}

.actionBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 230px;
  height: 48px;
}

.actionBarL {
  font-size: 14px;
  color: #808080;
  margin-left: 16px;
}

.actionBarL span {
  color: #3c3c3c;
  margin-left: 4px;
}

.actionBarR {
  width: 104px;
  height: 32px;
  border: 1px solid #fb5d5c80;
  border-radius: 4px;
  background-color: #fff6f6;
  margin-right: 16px;
  color: #fb5d5c;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uploadArea {
  width: 94.87%;
  height: 209px;
  margin: auto;
  background: #f6f9fa;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.actionBarRDisable {
  background-color: #e5e5e5;
  color: #808080;
  border: none;
}

.uploadAreaMain {
  color: #3c3c3c;
  font-size: 14px;
}

.uploadAreaMain img {
  width: 48px;
  height: 48px;
  margin: auto;
  display: block;
}

.btnBar {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  /* position: fixed;
    right: 0;
    bottom: 16px; */
}

.btnBarL {
  width: 88px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.btnBarR {
  width: 88px;
  height: 32px;
  background: #fb5d5c;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: #ffffff;
}
</style>
